import APIServer from './APIServer'


export default class CuratorAPI extends APIServer{ 

	async getCurators(zone) { 
		var url = "/curator"
		if (zone !== undefined && zone !== null) { 
			url += "?zone=" + zone
		}
		return await super.get(url)
	}

	async handleErrors(response) {
		if (!response.ok) {
			try {
				const errorBody = await response.json()
				const failBody = { code: -1, error: errorBody }
				return failBody
			} catch (e) {
				return { code: -1, error: e }
			}
		}
		return response.json();
	}
}

